import React from 'react';
import PhoneInputWithControl from 'react-phone-number-input/react-hook-form';

export const PhoneInputField = ({
  name,
  value,
  control,
  label,
  extraClasses = '',
  defaultCountry = 'US',
  disabled = false,
  countryCallingCodeEditable = true,
  addInternationalOption = false,
  limitMaxLength = true,
  international = true,
  error,
  onCountryChange = (_countryCode) => {},
  onChange = (country) => {},
}) => {
  const text = error || label || '';

  return (
    <div className="w--full d--flex flex--column">
      {text && (
        <label
          className={`label--control font--sm font--500 m-b--sm ${
            error ? 'text--danger' : 'text--black'
          }`}
        >
          {text}
        </label>
      )}
      <div
        className={`form--control w--full h-min--36 radius--sm p-l--md p-r--md ${error ? 'border-full--danger' : 'border-full--black-200'} d--flex`}
      >
        <PhoneInputWithControl
          className={`${extraClasses}`}
          autoComplete="off"
          disabled={disabled}
          readOnly={disabled}
          // flagComponent={() => null}
          internationalIcon={() => null}
          // onChange={(num) => {
          //   if (num?.length > 15) return;
          // }}
          onChange={onChange}
          {...{
            name,
            control,
            onCountryChange,
            defaultCountry,
            countryCallingCodeEditable,
            international,
            // limitMaxLength,
            addInternationalOption,
          }}
        />
      </div>
    </div>
  );
};
